import { Box, Button, Theme } from '@mui/material'
import styled from 'styled-components'

export const DNDContainer = styled(Box)<{
  theme: Theme
}>`
  background-color: ${({ theme }) => theme.palette.secondary.light};
  border: 1px dashed #000;
  width: 100%;
  padding: 10px;
`

export const BrowseFileButton = styled(Button)`
  border-radius: 6px !important;
`
